var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { space, position, bottom, display, flexDirection, justifyContent, alignItems, width, maxWidth, height, left, backgroundColor, backgroundRepeat, backgroundPosition, backgroundSize, fontSize, fontWeight, lineHeight, color, boxShadow, themeGet, } from 'styled-system';
import { themeHeight, themeMaxHeight, themeMaxWidth, themeWidth, themeTop, } from '../../common/theme/theme';
import { Grid, GridItem } from '../../common/components/Grid';
import { ResponsiveLazyImage, ResponsiveLazyImagePropsShape, } from '../../common/components/LazyImage';
import arrow from '../../common/assets/icons/arrow-left.svg';
import { Text } from '../../common/components/Text';
import { getPageAppTrackerProps, } from '../../common/tracking/getTrackerProps';
import dispatchTrackingEvent from '../../common/tracking/dispatchTrackingEvent';
var TeaserGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), color);
TeaserGrid.defaultProps = {
    px: [0, '14px', '36px', 6],
    bg: ['gray.2', 'white'],
};
var TEASER_X_GAP = [0, '10px', '12px', 3];
var TeaserGridItem = styled(GridItem)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
TeaserGridItem.defaultProps = {
    px: TEASER_X_GAP,
    mb: [3, 4, null, 5],
    w: [1, 1 / 2, null, 1 / 3],
};
var Teaser = styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  cursor: pointer;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  cursor: pointer;\n"])), position, display, justifyContent, width, height, color, boxShadow);
Teaser.defaultProps = {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    height: ['295px', '324px', '348px'],
    color: 'gray.10',
    boxShadow: ['0 2px 6px 0 rgba(192, 192, 192, 0.5)', 'none'],
};
var Image = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-image: ", ";\n  opacity: ", ";\n  transition: opacity 0.3s ease-in-out;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  background-image: ", ";\n  opacity: ", ";\n  transition: opacity 0.3s ease-in-out;\n"])), width, height, backgroundRepeat, backgroundPosition, backgroundSize, function (props) { return "url(" + props.image + ")"; }, function (props) { return (props.show ? '1' : '0'); });
Image.defaultProps = {
    width: 1,
    height: ['64%', '100%'],
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
};
var InformationBoxWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  box-sizing: border-box;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  box-sizing: border-box;\n"])), position, themeTop, bottom, display, flexDirection, alignItems, width, space, left);
InformationBoxWrapper.defaultProps = {
    position: 'absolute',
    themeTop: ['auto', 3, 4, '28px'],
    bottom: [0, 'auto'],
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: 1,
    left: 0,
};
var InformationBox = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  box-sizing: border-box;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  box-sizing: border-box;\n"])), display, flexDirection, justifyContent, alignItems, space, backgroundColor, maxWidth, width);
InformationBox.defaultProps = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: ['center', 'flex-start'],
    alignItems: ['center', 'flex-start'],
    px: 3,
    py: [3, 2],
    backgroundColor: 'white',
    maxWidth: ['100%', '85%'],
    width: 1,
};
var EllipsisParagraph = styled(Text)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), space, maxWidth, fontSize, lineHeight);
EllipsisParagraph.defaultProps = {
    as: 'p',
    mt: 0,
    mb: 0,
    maxWidth: '100%',
    fontSize: [4, null, null, 5],
    lineHeight: [3, null, null, '28px'],
};
var Category = styled(EllipsisParagraph)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  text-transform: uppercase;\n  border-bottom: 3px solid ", ";\n"], ["\n  text-transform: uppercase;\n  border-bottom: 3px solid ", ";\n"])), themeGet('colors.gray.7'));
var Title = styled(EllipsisParagraph)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), fontSize, fontWeight, lineHeight, space);
Title.defaultProps = __assign(__assign({}, EllipsisParagraph.defaultProps), { fontSize: [5, null, null, '22px'], fontWeight: 'bold', lineHeight: ['28px', null, null, 4], mt: [2, '12px'], mb: [1, 0] });
var Subtitle = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), display, justifyContent, alignItems, width);
Subtitle.defaultProps = {
    display: 'inherit',
    justifyContent: ['center', 'inherit'],
    alignItems: 'center',
    width: 1,
};
var LeftArrow = styled.img(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  transform: rotate(180deg);\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  transform: rotate(180deg);\n"])), themeWidth, themeMaxWidth, themeHeight, themeMaxHeight);
LeftArrow.defaultProps = {
    src: arrow,
    alt: '',
    themeWidth: 4,
    themeMaxWidth: 4,
    themeHeight: 4,
    themeMaxHeight: 4,
};
var isMultipleOfThree = function (n) { return n % 3 === 0; };
var CommonInspirationalTeaser = function (_a) {
    var _b = _a.items, items = _b === void 0 ? [] : _b, __legacy_shop_reboot_max_width = _a.__legacy_shop_reboot_max_width;
    useEffect(function () {
        var inspirationalTeaserPromotions = items.map(function (item, index) { return ({
            name: item.tracking.name,
            placement: item.tracking.placement,
            position: index,
        }); });
        dispatchTrackingEvent({
            event: 'promoView',
            eventAction: 'view',
            eventCategory: 'promotion',
            eventData: {
                promotions: inspirationalTeaserPromotions,
            },
        });
    }, [items]);
    return (React.createElement(TeaserGrid, { legacyShopRebootMaxWidth: __legacy_shop_reboot_max_width }, items.map(function (_a, index) {
        var category = _a.category, title = _a.title, subtitle = _a.subtitle, teaserImage = _a.image, enhancedImage = _a.enhancedImage, link = _a.link, _b = _a.tracking, _c = _b === void 0 ? {} : _b, name = _c.name, placement = _c.placement;
        return !isMultipleOfThree(index + 1) ? (React.createElement(TeaserGridItem, { key: "inspirational-teaser-" + index, "data-testid": "inspirational-teaser-" + index, "data-type": "regular" },
            React.createElement(Teaser, __assign({}, getPageAppTrackerProps({
                'data-testid': 'inspirational-teaser-wrapper',
                'data-prefetch': true,
                href: link,
            }, {
                event: 'promoClick',
                eventData: {
                    promotions: [
                        {
                            name: name,
                            placement: placement,
                            position: index,
                        },
                    ],
                },
            })),
                React.createElement(ResponsiveLazyImage, __assign({}, teaserImage), function (_a) {
                    var image = _a.image, loaded = _a.loaded, thumbnail = _a.thumbnail, intersected = _a.intersected, innerRef = _a.innerRef;
                    return (React.createElement(Image, { "data-testid": "inspirational-teaser-image", ref: innerRef, show: intersected, image: loaded ? image : thumbnail }));
                }),
                React.createElement(InformationBoxWrapper, { "data-testid": "inspirational-teaser-information-box" },
                    React.createElement(InformationBox, null,
                        React.createElement(Category, { "data-testid": "inspirational-teaser-category" }, category),
                        React.createElement(Title, { "data-testid": "inspirational-teaser-title" }, title),
                        React.createElement(Subtitle, { "data-testid": "inspirational-teaser-subtitle" },
                            React.createElement(EllipsisParagraph, null, subtitle),
                            React.createElement(LeftArrow, { "data-testid": "left-arrow" }))))))) : (React.createElement(TeaserGridItem, { key: "inspirational-teaser-" + index, "data-testid": "inspirational-teaser-" + index, "data-type": "enhanced", width: [1, null, null, 1 / 3] },
            React.createElement(Teaser, __assign({ justifyContent: ['center', 'flex-start', null, 'center'] }, getPageAppTrackerProps({
                'data-testid': 'inspirational-teaser-wrapper',
                'data-prefetch': true,
                href: link,
            }, {
                event: 'promoClick',
                eventData: {
                    promotions: [
                        {
                            name: name,
                            placement: placement,
                            position: index,
                        },
                    ],
                },
            })),
                React.createElement(ResponsiveLazyImage, __assign({}, enhancedImage, { mobile: teaserImage.mobile, large_desktop: teaserImage.desktop }), function (_a) {
                    var image = _a.image, loaded = _a.loaded, thumbnail = _a.thumbnail, intersected = _a.intersected, innerRef = _a.innerRef;
                    return (React.createElement(Image, { "data-testid": "inspirational-teaser-image", ref: innerRef, show: intersected, image: loaded ? image : thumbnail }));
                }),
                React.createElement(InformationBoxWrapper, { "data-testid": "inspirational-teaser-information-box", paddingRight: [0, TEASER_X_GAP[1], TEASER_X_GAP[2], 0], width: [1, 1 / 2, null, 1] },
                    React.createElement(InformationBox, null,
                        React.createElement(Category, { "data-testid": "inspirational-teaser-category" }, category),
                        React.createElement(Title, { "data-testid": "inspirational-teaser-title" }, title),
                        React.createElement(Subtitle, { "data-testid": "inspirational-teaser-subtitle" },
                            React.createElement(EllipsisParagraph, null, subtitle),
                            React.createElement(LeftArrow, { "data-testid": "left-arrow" })))))));
    })));
};
CommonInspirationalTeaser.propTypes = {
    /** Array of items */
    items: PropTypes.arrayOf(PropTypes.shape({
        /** Item's category */
        category: PropTypes.string,
        /** Item's title */
        title: PropTypes.string,
        /** Item's subtitle */
        subtitle: PropTypes.string,
        /** Item's image */
        image: PropTypes.shape(__assign({ 
            /** Alternative image text. */
            alt: PropTypes.string }, ResponsiveLazyImagePropsShape)),
        /** Item's enhanced image */
        enhancedImage: PropTypes.shape(__assign({ 
            /** Alternative image text. */
            alt: PropTypes.string }, ResponsiveLazyImagePropsShape)),
        /** Item's link */
        link: PropTypes.string,
        /** Tracking props */
        tracking: PropTypes.shape({
            /** Tracking item name */
            name: PropTypes.string,
            /** Tracking item placement */
            placement: PropTypes.string,
        }),
    }).isRequired),
    /** Should the max width be capped by current Reboot max width (default: true) */
    __legacy_shop_reboot_max_width: PropTypes.bool,
};
CommonInspirationalTeaser.defaultProps = {
    __legacy_shop_reboot_max_width: false,
};
export default CommonInspirationalTeaser;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
